import { injectIntl } from 'react-intl';
import { formValues } from 'utils/formValues';
import ThankYou from './ThankYou';
import config from './config';

export const CONFIG = config;

export default injectIntl(formValues('displayMarginText')(ThankYou));
